import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import useChickenConfig from "../hooks/useChickenConfig";
import ChickenRoadGame from "../components/game/ChickenRoadGame";
import "../styles/chicken.css";

// Page khulte hi GET /chicken/config call hoti hai, config aane par game dikhta hai
export default function Game() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { config, activeRound, loading, error, reload } = useChickenConfig();

  if (loading) {
    return (
      <div className="cr-state">
        <p>Loading game...</p>
      </div>
    );
  }

  if (error || !config) {
    return (
      <div className="cr-state">
        <div>
          <p>{error || "Config load nahi hui."}</p>
          <button onClick={reload}>Retry</button>
          <button
            className="alt"
            onClick={() => {
              logout();
              navigate("/login", { replace: true });
            }}
          >
            Logout
          </button>
        </div>
      </div>
    );
  }

  return <ChickenRoadGame config={config} activeRound={activeRound} />;
}
